import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from '@/lib/observability';

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError(error, { componentStack: info.componentStack ?? '' });
  }

  reset = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.fallback) return this.props.fallback(error, this.reset);
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-lg font-semibold">应用启动失败</h1>
        <p className="max-w-md text-sm text-muted-foreground">{error.message}</p>
        <button
          type="button"
          onClick={this.reset}
          className="h-9 rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground"
        >
          重试
        </button>
      </div>
    );
  }
}
